import { getStoreCategoryString } from '../store/StoreUtils.ts';
import { getLobbyImagePath } from '../ui_utils/Utils.ts';
export function toOwnedStoreItems(items) {
    return items.map((item)=>({
            name: item.name,
            imageSrc: getLobbyImagePath(item.image),
            categorySlug: getStoreCategoryString(item.category)
        }));
}
